import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

import {
  CreateCompanyJobPayload,
  UpdateCompanyJobPayload,
} from "../Types/CompanyProfile/CompanyJobs";

export const COMPANY_JOBS_QUERY_KEY = ["company-job-title"];
export const VIEW_COMPANY_JOBS_QUERY_KEY = ["view-company-job-title"];

export const companyjobTitleService = {
  createCompanyJobs: async (payload: CreateCompanyJobPayload) => {
    const response = await api.post(`api/company-job-title`, payload);
    return response.data;
  },
  updateCompanyJobs: async (id: number, payload: UpdateCompanyJobPayload) => {
    const response = await api.patch(`api/company-job-title/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/company-job-title/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  getCompanyJobById: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/company-job-title/${id}`, { headers: getAuthHeaders() })
        .then((res) => res.data.data),
    ),
  viewAllJobsByCompany: async (company_code: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-company-job-title?company_code=${company_code}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data.data),
    ),
};
